module.exports = __webpack_public_path__ + "static/media/Gilmer-Medium.5f3f4f44.otf";